import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex items-center rounded-(--radius-full) border px-2.5 py-0.5 font-medium text-xs transition-colors focus:outline-none focus:ring-(--color-ring) focus:ring-2 focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-(--color-cta-primary) text-(--color-cta-primary-foreground) hover:bg-(--color-cta-primary-hover)",
				secondary:
					"border-transparent bg-(--color-muted) text-(--color-foreground) hover:bg-(--color-neutral-200)",
				destructive:
					"border-transparent bg-(--color-error-500) text-(--color-neutral-0) hover:bg-(--color-error-600)",
				outline: "text-(--color-foreground)",
				success:
					"border-transparent bg-(--color-success-50) text-(--color-success-700)",
				warning:
					"border-transparent bg-(--color-warning-50) text-(--color-warning-700)",
				info: "border-transparent bg-(--color-info-50) text-(--color-info-700)",
				neutral:
					"border-transparent bg-(--color-muted) text-(--color-muted-foreground)",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<span className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}

export { Badge, badgeVariants };
